import { createContext, useContext } from 'react'

const DragContext = createContext({})

export const useDragContext = () => useContext(DragContext)

export default DragContext
